export default function translate(i18n, propriete) {
  if (propriete.toLowerCase().endsWith('actionlogistique')) return i18n.t('demandeLogistique.creationOrUpdate.actionLogistique');
  if (propriete.toLowerCase().endsWith('dateplanification')) return i18n.t('demandeLogistique.creationOrUpdate.datePlanification');
  if (propriete.toLowerCase().endsWith('demandeurid')) return i18n.t('demandeLogistique.creationOrUpdate.demandeur');
  if (propriete.toLowerCase().endsWith('typeotid')) return i18n.t('demandeLogistique.creationOrUpdate.typeOt');
  return propriete;
}
